document.addEventListener("DOMContentLoaded", function() {
  const intervalTime = 250;

  const initPopupOverride = setInterval(function() {
    const flashyPopup = document.querySelector('flashy-popup');
    
    if (flashyPopup && flashyPopup.shadowRoot) {
      const closeContainer = flashyPopup.shadowRoot.querySelector('.fls-close-popup');
      
      if (closeContainer && !closeContainer.dataset.patched) {
        clearInterval(initPopupOverride);
        closeContainer.dataset.patched = "true"; 
        
        const customStyles = document.createElement('style');
        customStyles.innerHTML = `
          .fls-close-popup {
              z-index: 99 !important;
              left: 6px !important;
              top: 6px !important;
              width: 56px !important;
              height: 56px !important;
              background-image: url("data:image/svg+xml,%3Csvg width='57' height='57' viewBox='0 0 57 57' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M42.4264 14.4264C42.8169 14.8169 42.8169 15.4501 42.4264 15.8406L29.6985 28.5685L42.4264 41.2965C42.8169 41.687 42.8169 42.3202 42.4264 42.7107C42.0359 43.1012 41.4027 43.1012 41.0122 42.7107L28.2843 29.9828L15.5563 42.7107C15.1658 43.1012 14.5327 43.1012 14.1421 42.7107C13.7516 42.3202 13.7516 41.687 14.1421 41.2965L26.8701 28.5685L14.1421 15.8406C13.7516 15.4501 13.7516 14.8169 14.1421 14.4264C14.5327 14.0359 15.1658 14.0359 15.5563 14.4264L28.2843 27.1543L41.0122 14.4264C41.4027 14.0359 42.0359 14.0359 42.4264 14.4264Z' fill='%23999999'/%3E%3C/svg%3E%0A") !important;
              background-repeat: no-repeat !important;
              background-position: center !important;
              display: block !important;
          }
          .fls-close-popup svg {
              display: none !important;
          }
          .fls-close-popup a.fls-close {
              display: block !important;
              width: 100% !important;
              height: 100% !important;
          }
        `;
        flashyPopup.shadowRoot.appendChild(customStyles);

        const forceKillPopup = function(e) {
          e.preventDefault();
          flashyPopup.remove(); 
        };
        
        const closeBtn = closeContainer.querySelector('a.fls-close');
        if (closeBtn) {
          closeBtn.addEventListener('click', forceKillPopup);
        }
        
        const allButtons = flashyPopup.shadowRoot.querySelectorAll('button');
        allButtons.forEach((btn) => {
          const rawText = btn.textContent;
          if (rawText && rawText.includes('אוותר ואשלם מחיר מלא')) {
            btn.textContent = 'מעבר לאתר ללא הטבה';
            btn.addEventListener('click', forceKillPopup);
          }
        });
        
        const overlay = flashyPopup.shadowRoot.querySelector('.fls-popup-overlay');
        if (overlay) {
          overlay.addEventListener('click', function(e) {
            if (!e.target.closest('.fls-popup')) {
              forceKillPopup(e);
            }
          });
        }
      }
    }
  }, intervalTime);
});

document.addEventListener("DOMContentLoaded", function() {
  const stickyBar = document.querySelector('product-sticky-bar');

  if (stickyBar) { 
    const updateIconsPosition = () => { 
      if (window.innerWidth <= 699) {
        const hasFormVisible = stickyBar.classList.contains('form-visible');
        const isBarVisible = !hasFormVisible; 

        if (isBarVisible) {
          document.body.classList.add('mobile-sticky-bar-active');
        } else {
          document.body.classList.remove('mobile-sticky-bar-active');
        }
      } 
    };
    
    updateIconsPosition();
    
    const stickyObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'class') {
          updateIconsPosition();
        }
      });
    });

    stickyObserver.observe(stickyBar, { attributes: true });
  }  
});


/* YUVALL - Force product gallery thumbnails to respond immediately */
document.addEventListener(
  "click",
  function (event) {
    const thumb = event.target.closest(
      'product-gallery-navigation button.product-gallery__thumbnail'
    );

    if (!thumb) return;

    const nav = thumb.closest("product-gallery-navigation");
    if (!nav) return;

    const carouselId = nav.getAttribute("aria-controls");
    const carousel = carouselId ? document.getElementById(carouselId) : null;

    if (!carousel) return;

    const mediaId = thumb.getAttribute("data-media-id");
    const mediaPosition = parseInt(thumb.getAttribute("data-media-position"), 10);

    let targetMedia = null;

    if (mediaId && window.CSS && CSS.escape) {
      targetMedia = carousel.querySelector(
        '[data-media-id="' + CSS.escape(mediaId) + '"]'
      );
    }

    if (!targetMedia && mediaPosition) {
      const mediaItems = carousel.querySelectorAll(".product-gallery__media");
      targetMedia = mediaItems[mediaPosition - 1];
    }

    if (!targetMedia) return;

    event.preventDefault();
    event.stopPropagation();

    nav.querySelectorAll("button.product-gallery__thumbnail").forEach(function (button) {
      button.setAttribute("aria-current", "false");
    });

    thumb.setAttribute("aria-current", "true");

    carousel.scrollTo({
      left: targetMedia.offsetLeft,
      top: targetMedia.offsetTop,
      behavior: "auto"
    });
  },
  true
);